<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Estoques"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Produto</label>
            <multiselect
              v-model="filter.code"
              :options="products"
              placeholder="Produto"
              label="description"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="code"
              @search-change="getProducts"
            ></multiselect>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Empresa</label>
            <multiselect
              v-model="filter.enterprises"
              :options="enterprises"
              label="iden_emp"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="FABRICANTE"
              track-by="codi_emp"
              @search-change="getEnterprises"
            />
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <base-input
              class="mb-3"
              v-model="desc_psv"
              placeholder="Descrição do Produto"
              label="Descrição"
            >
            </base-input>
            <div slot="footer" class="row justify-content-end mr-1">
              <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
              <base-button
                type="primary"
                @click="initStocks"
                v-loading="isLoading"
                >Pesquisar</base-button
              >
            </div>
          </div>
        </div>
      </card>
    </div>
    <card
      v-show="Object.keys(stocks).length"
      ref="report"
      v-loading="isLoading"
    >
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Disponíveis em estoque
        </h6>
        <card id="tableId">
          <el-table
            v-if="stocks.length > 0"
            min-width="500px"
            :data="stocks"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
          >
            <el-table-column type="expand" width="100">
              <template slot-scope="props">
                <table class="table table-success table-striped">
                  <thead>
                    <tr>
                      <th>EF</th>
                      <th>PCNR</th>
                      <!--- PEDIDO DE COMPRA NAO RECEBIDO -->
                      <th>PVNE</th>
                      <!--- PEDIDO DE COMPRA NAO ENTREGUE -->
                      <th>VF</th>
                      <!--- VENDA PARA ENTREGAR FUTURA -->
                      <th>RDR</th>
                      <!--- REMESSA DEP/ARM. RECEBIDA -->
                      <th>RDE</th>
                      <!--- REMESSA DEP/ARM. EMITIDA -->
                      <th>VA</th>
                      <!--- VENDA ANTECIPADA -->
                      <th>PVC</th>
                      <!--- PEDIDO DE VENDA EM CARTEIRA -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ props.row.ef }}
                      </td>
                      <td>
                        {{ props.row.pcrn }}
                      </td>
                      <td>
                        {{ props.row.pvne }}
                      </td>
                      <td>
                        {{ props.row.vf }}
                      </td>
                      <td>
                        {{ props.row.rdr }}
                      </td>
                      <td>
                        {{ props.row.rde }}
                      </td>
                      <td>
                        {{ props.row.va }}
                      </td>
                      <td>
                        {{ props.row.pvc }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </el-table-column>
            <el-table-column
              label="Código do Produto"
              min-width="200px"
              prop="codi_psv"
            />
            <el-table-column
              label="Nome"
              min-width="200px"
              style="text-align: center;"
              prop="desc_psv"
            />
            <el-table-column
              label="Empresa"
              min-width="200px"
              style="text-align: center;"
              prop="cademp.iden_emp"
            />
            <el-table-column
              label="Disponível"
              min-width="200px"
              prop="disponivel"
            />
            <el-table-column label="Físico" min-width="200px" prop="fisico" />
          </el-table>
        </card>
      </div>
      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="current"
          :total="count"
          :perPage="per_page"
        >
        </base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { DatePicker, Row } from "element-ui";
import { Table, TableColumn } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import PageTitle from "@/layouts/PageTitle";

export default {
  components: {
    Multiselect,
    LineChart,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    PageTitle,
  },
  data() {
    return {
      isLoading: false,
      paginated_data: [],
      filter: {
        stocks: [],
        code: {},
        product: {},
        enterprises: {},
        codi_emp: {},
      },
      stocks: [],
      codi_psv: "",
      codi_emp: "",
      desc_psv: "",
      current: 1,
      count: 1,
      per_page: 1,
      products: [],
      enterprises: [],
      stocks_params: [],
    };
  },
  mounted() {
    this.getProducts();
    this.getEnterprises();
  },
  methods: {
    initStocks(current = null) {
      if (this.codi_psv || this.codi_emp) {
        this.isLoading = true;
        this.$http.secured
          .get("/api/v1/report/stocks_data", {
            params: {
              page: current,
              codi_psv: this.codi_psv ? this.codi_psv : null,
              codi_emp: this.codi_emp ? this.codi_emp : null,
              desc_psv: this.desc_psv ? this.desc_psv : null,
            },
          })
          .then((response) => {
            this.current  = response.data.current;
            this.count    = response.data.count;
            this.per_page = response.data.per_page;
            this.stocks   = response.data.stocks;
            
            if (!(this.stocks && this.stocks.length)) {
              this.$toasted.global.defaultWarnig({ msg: "Produto não encontrado" });
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      } else {
        this.$toasted.global.defaultWarnig({
          msg:
            "Insira um produto ou fabricante para realizar a busca",
        });
      }
    },
    getProducts(q = "") {
      this.$http.secured
        .get("/api/v1/products", {
          params: { q: { description: q, status: "A" } },
        })
        .then((response) => {
          this.products = response.data["products"];
        })
        .catch((error) => this.setError(error, "failed to fetch products"));
    },
    getEnterprises(q = "") {
      this.$http.secured
        .get("/api/v1/report/enterprise_data", {
          params: { q: { iden_emp: q, situ_emp: "A" } },
        })
        .then((response) => {
          this.enterprises = response.data;
          console.log(response.data);
          this.enterprises.shift();
          this.enterprises.shift();

        })
        .catch((error) =>
          this.setError(
            error,
            this.$toasted.global.defaultWarnig({
              msg: "Fabricantes não encontrados",
            })
          )
        );
    },
    clearFilters() {
      this.filter.code = {},
      this.filter.enterprises = {},
      this.desc_psv = ""
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Soma";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toLocaleString("pt-BR", { style: "currency", currency: "brl" });
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    changePage(page) {
      this.initStocks(page);
    },
  },
  watch: {
    "filter.code"() {
      this.codi_psv = this.filter.code.code;
      console.log(this.filter.code);
    },
    "filter.enterprises"() {
      this.codi_emp = this.filter.enterprises.codi_emp;
      console.log(this.codi_emp);
    },
  },
};
</script>
<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
.el-table__footer {
  font-weight: bold;
  width: 200px;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: overlay;
}
</style>
